<template>
    <div>
        <div style="font-weight: bold;font-size: 18px;">合约争霸赛队长招募审核</div>
        <br>
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item label="战队名称">
               <el-input v-model="queryCondition.name"></el-input>
            </el-form-item>
            <el-form-item label="队长称号">
                <el-input v-model="queryCondition.captainNickname"></el-input>
            </el-form-item>
            <el-form-item label="活动比赛">
                <el-select v-model="queryCondition.activityId" placeholder="请选择" clearable>
                    <el-option v-for="item in listInfo" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核状态">
                <el-select v-model="qStatus" placeholder="请选择" clearable>
                    <el-option v-for="item in queryStatus" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="query(1)">搜索</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="auditList">
            <el-table-column label="申请ID" prop="id"></el-table-column>
            <el-table-column label="申请账户" prop="captainUserId"></el-table-column>
            <el-table-column label="比赛名称" prop="activityId">
                <template slot-scope="scope">{{parseActiveName(scope.row.activityId)}}</template>
            </el-table-column>
            <el-table-column label="战队名称" prop="name"></el-table-column>
            <el-table-column label="队长称号" prop="captainNickname"></el-table-column>
            <el-table-column label="联系方式" prop="captainTel"></el-table-column>
            <el-table-column label="微信号" prop="captainWechat"></el-table-column>
            <el-table-column label="战队简介" prop="remark"></el-table-column>
            <el-table-column label="申请状态" prop="status">
                <template slot-scope="scope">{{parseAuditStatus(scope.row.status,scope.row.refuseExplain)}}</template>
            </el-table-column>
            <el-table-column label="拒绝原因" prop="refuseExplain">
                <template slot-scope="scope">{{scope.row.status ? '' : scope.row.refuseExplain}}</template>
            </el-table-column>
            <el-table-column label="申请时间" prop="createdTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.createdTime)}}</template>
            </el-table-column>
            <el-table-column label="处理时间" prop="auditTime">
                <template slot-scope="scope">{{parseDateTime(scope.row.auditTime)}}</template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" @click="auditHandle(scope.row)">{{parseOpType(scope.row.status,scope.row.refuseExplain) ? '切换状态' : '审核'}}</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="auditTotal" :page-size="10" :current-page="queryCondition.page"
                       @current-change="query"></el-pagination>

        <el-dialog title="队长审核" :visible.sync= "showAudit" @close="closeAudit">
            <el-form>
                <el-form-item label="审核操作">
                    <el-select v-model="auditInfo.status" placeholder="请选择">
                        <el-option v-for="item in statuses" :key="item.code" :label="item.desc" :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="拒绝理由" v-show="!auditInfo.status">
                    <el-input v-model="auditInfo.refuseExplain"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeAudit">取消</el-button>
                    <el-button type="primary" @click="audit()">确认</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog title="切换状态" :visible.sync= "showStatus" @close="closeAudit">
            <el-form>
                <el-form-item label="是否把审核状态切换至">
                    <span style="color: red">{{auditInfo.status ? '审核不通过' : '审核通过'}}</span>?
                </el-form-item>
                <el-form-item label="拒绝理由" v-show="auditInfo.status">
                    <el-input v-model="auditInfo.refuseExplain"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeAudit">取消</el-button>
                    <el-button type="primary" @click="tabAudit()">确认</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

    </div>
</template>

<script>
    import './store';
    import api from './api';
    import {mapActions, mapState} from 'vuex';
    export default {
        name: "recruit",
        data(){
            return {
                queryCondition:{
                    activityId:'',
                    name:'',
                    captainNickname:'',
                    status:'',
                    page:1,
                    showFalse:true,//展示未审核
                },
                qStatus:'',
                queryStatus:[{code:0,desc:'未审核'},{code:1,desc:'审核通过'},{code:2,desc:'审核不通过'}],
                statuses:[{code:true,desc:'审核通过'},{code:false,desc:'审核不通过'}],
                showAudit: false,
                showStatus: false,
                auditInfo:{
                    activityId: '',
                    refuseExplain: '',
                    teamId: '',
                    status: 0,
                },
            }
        },
        computed : {...mapState('contractActivity',['listInfo','auditList','auditTotal'])},
        created(){
            this.queryLists();
            this.queryAuditList(this.queryCondition);
        },
        methods:{
            ...mapActions('contractActivity',['queryLists','queryAuditList']),
            query(val){
                this.queryCondition.showFalse = true;
               this.queryCondition.page = val;
               if (this.qStatus === 0) {
                   this.queryCondition.status = false;
                   this.queryCondition.showFalse = false;
               }
               if (this.qStatus === 1){
                   this.queryCondition.status = true;
               }
                if (this.qStatus === 2){
                    this.queryCondition.status = false;
                }
               this.queryAuditList(this.queryCondition);
            },
            closeAudit() {
                this.auditInfo = {status: 0};
                this.showAudit = false;
                this.showStatus = false;
            },
            parseActiveName(activityId) {
                for(let index in  this.listInfo) {
                    if (this.listInfo[index].id === activityId){
                        return  this.listInfo[index].name;
                    }
                }
            },
            auditHandle(row){
                let auditAble = false;
                this.auditInfo.activityId = row.activityId;
                this.auditInfo.teamId = row.id;
                this.auditInfo.status = row.status;
                for(let index in  this.listInfo) {
                    if (this.listInfo[index].id === row.activityId){
                        auditAble = this.listInfo[index].teamTime > new Date().getTime();
                        break;
                    }
                }
               if (row.status || row.refuseExplain) {
                  if (auditAble) {
                      this.showStatus = true;
                  }else {
                      this.$message.error('本期活动组队时间已结束，不能切换状态');
                  }
               }else {
                   this.showAudit = true;
               }
            },
            audit(){
                if (!this.auditInfo.status && !this.auditInfo.refuseExplain) {
                    this.$message.error('请输入审核失败理由');
                    return;
                }
                api.auditStatus(this.auditInfo).then(response =>{
                    this.$message('审核状态变更成功');
                    this.queryAuditList(this.queryCondition);
                    this.closeAudit();
                })
            },

            tabAudit(){
                this.auditInfo.status = !this.auditInfo.status;
                this.audit();
            },
            parseDateTime(time){
                let now = new Date(time);
                let year=now.getFullYear();
                let month=now.getMonth()+1;
                let date=now.getDate();
                let hour=now.getHours();
                let minute=now.getMinutes();
                let second=now.getSeconds();
                return year+"-"+month+"-"+date+" "+hour+":"+minute+":"+second;
            },
            parseAuditStatus(status,refuseExplain){
                if (status === true){
                    return '审核成功';
                }
                if (refuseExplain){
                    return '审核失败';
                }
                return '未审核';
            },
            parseOpType(status,refuseExplain){
                if (status === true){
                    return true;
                }
                return !!refuseExplain;

            }
        }
    }
</script>

<style scoped>

</style>